import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SearchFacetComponent} from './search-facet.component';

@NgModule({
  declarations: [SearchFacetComponent],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule,
  ],
  exports: [SearchFacetComponent],
  providers: [],
})
export class SearchFacetModule { }